import Icon from "components/Icon";
import React, { createContext, useCallback, useEffect, useRef, useState } from "react";
import { makeid } from "utils/random";

interface IContentPageMenu extends React.HTMLProps<HTMLElement>{
  selectedDefault?:number;
 }

export default function ContentPageMenu({
  children,
  selectedDefault
}:IContentPageMenu){
  const refMenu = useRef<HTMLDivElement>(null);
  const [ ID ] = useState(`pagedefault-menu-content-${makeid(7)}-${makeid(5)}`);
  const [ ID_LIST ] = useState(`pagedefault-menu-content-${makeid(7)}-${makeid(5)}`);
  const [ indexSelected, setIndexSelect ] = useState<string>("");
  const [ listPages, setListPages ] = useState<any>({}); 

  const addPage = useCallback((id:string, item:any)=>{
    setListPages((old:any)=>{
      let aux = {...old};
      aux[id] = item;
      
      return aux;
    });
  },[]);

  const removePage = useCallback((id:string)=>{
    setListPages((old:any)=>{
      delete old[id];
      return {...old};
    });
  },[]);

  const setPage = useCallback((id:string)=>{
    setIndexSelect(id);
  },[]);
  
  useEffect(()=>{
    let l:string[] = Object.keys(listPages);
    let index = selectedDefault || 0;
    if(index >= l.length) index=0;
    if (l.length>0) {
      setIndexSelect((old:any)=>{
        if(old === "" || l.indexOf(old) === -1){
          return l[index];
        }
        return old;
      });
    }
    
  },[listPages, selectedDefault]);
  
  useEffect(()=>{
    if(refMenu && refMenu.current){
      let list = refMenu.current.getElementsByClassName("pagedefault-menu-item");
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        if(element.id === `pagedefault-menu-item-${indexSelected}`){
          element.classList.add("pagedefault-menu-item-selected");
        } else {
          element.classList.remove("pagedefault-menu-item-selected");
        }
      }
    } 
  },[indexSelected])
  
  function renderPage(){
    try {
      let item = listPages[indexSelected];
      if(item){
        return item;
      }
      return <></>
    } catch (error) {
      return <></>;
    }
  }  
  
  return (
    <div ref={refMenu} className={"pagedefault-content pagedefault-content-menu"}>
      <ContextContentPageMenu.Provider value={{
        refMenu,
        setPage,
        addPage,
        removePage
      }}>
        <div id={ID} className="pagedefault-menu-content">
          {renderPage()}
        </div>
        <div className="pagedefault-menu" id={ID_LIST}>
          <div className="pagedefault-menu-btn" onClick={()=>{
            if(refMenu && refMenu.current){
              if(refMenu.current.classList.contains("pagedefault-content-menu-modify")){
                refMenu.current.classList.remove("pagedefault-content-menu-modify");
              } else {
                refMenu.current.classList.add("pagedefault-content-menu-modify");
              }
            }
          }}>
            <Icon name="bars"/>
          </div>
          {children}
        </div>
      </ContextContentPageMenu.Provider>
    </div>
  )
}

interface IContextContentPageMenu{
  refMenu?: React.RefObject<HTMLDivElement>;
  setPage?: Function;
  addPage?: (id:string, item: any) => void;
  removePage?: (item: any) => void;
};

export const ContextContentPageMenu = createContext<IContextContentPageMenu>({});